<template>
  <div @closeclick="cloture()">
    <div class="card modal-card-border infoWindowMap">
      <div class="card-content">
        <div>
          <div class="columns">
            <div class="column is-9">
              <h1 class="is-5">
                <span class="subtitle">
                  Emplacement
                </span>
                <span class="title is-5">{{currentMarker.namePlace}}</span>
              </h1>
              <p class="subtitle is-7" v-if="currentMarker.codeFaces">
                Face(s) : {{currentMarker.codeFaces}}
              </p>
            </div>
          </div>
          <div class="columns detail-component">
            <div class="column is-5">
              <img :src="currentMarker.urlPhoto"
                   v-if="currentMarker.urlPhoto"
                   style="max-height:220px">
              <img v-else :src="currentMarker.img">
              <br/>
              <span class="pagination-link is-current distance">{{marker.distance}} km</span>
            </div>
            <div class="column is-8">
              <h1 class="subtitle is-6 information-title">Informations</h1>
              <div class="columns">
                <div class="column is-6">
                  <p class="information">Adresse commerciale</p>
                  <span>{{currentMarker.adresse1}}</span>
                  <span v-if="currentMarker.adresse2">{{currentMarker.adresse2}} </span>
                  <span v-if="currentMarker.adresse3">{{currentMarker.adresse3}} </span>
                  <span>{{currentMarker.ville}}</span>
                  <br>
                  <p class="information">Format</p>
                  <span>{{currentMarker.format}}</span>
                  <br>
                  <p class="information">Matériel</p>
                  <span>{{currentMarker.materiel}}</span>
                  <br>
                </div>
                <div class="column is-6">
                  <p class="information">En venant de</p>
                  <span>{{currentMarker.enVenantDe}}</span>
                  <br>
                  <p class="information">En allant vers</p>
                  <span>{{currentMarker.enAllantVers}}</span>
                  <br>
                  <p class="information">Eclairé</p>
                  <span>{{currentMarker.eclaire}}</span>
                  <br>
                  <p class="information">Nombre de propositions :</p>
                  <span>{{currentMarker.nbPropositions}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'info-window-map',
  props: {
    marker: Object,
  },
  data() {
    return {};
  },
  computed: {
    currentMarker() {
      return this.marker.panneaux[this.marker.indexPanneauCourant];
    },
  },
  methods: {
    cloture() {
      this.$emit('closeInfoWindow');
    },
  },
};

</script>

<style scoped>
.distance{
  margin-left: 0px;
  margin-top: -33px;
}

.columns{
  margin:0px;
}

  .information {
    font-size:14px;
  }

  .information-title {
    margin-left:10px;
    margin-bottom:0;
  }

.arrow {
  height: 50vh;
}
</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/panier/infoWindowMap.vue